export type ActionType = 'insert' | 'replace' | 'discard';

export enum ACTIONS {
	ACTION_COMPLETED = 'ACTION_COMPLETED',
	CLEAR_ACTION_COMPLETED = 'CLEAR_ACTION_COMPLETED',
}

export interface ActionCompletedAction {
	data: {
		actionType: ActionType;
		prompt: string;
	};
	type: ACTIONS.ACTION_COMPLETED;
}

export interface ClearActionCompletedAction {
	type: ACTIONS.CLEAR_ACTION_COMPLETED;
}

export interface AIPromptActionPluginState {
	/**
	 * AI action completion state for prompt action
	 */
	actionType?: ActionType;
	prompt?: string;
}

export type PromptAction = ActionCompletedAction | ClearActionCompletedAction;
